import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/EventsAwardsAccordionHeader";
import { OCBC_BANKING_URL } from "@util/constant";

/**
 * Component to render OCBC bank section on Partners page
 */
const OCBCBankSection = (): React.ReactElement => {
  return (
    <div className="bg-gray-150" data-testid="ocbc-bank-section-component">
      <AccordionV2
        testId="ocbc-bank"
        className="border-none py-2"
        headerChildren={
          <EventsAwardsAccordionHeader title="OCBC Bank" className="px-0" />
        }
        arrowClassName="h-auto w-auto -rotate-90 border-none"
        isArrowRight
      >
        <div className="px-6 pb-2 pt-6">
          <p>
            OCBC Bank is the longest established Singapore bank, formed in 1932
            from the merger of three local banks, the oldest of which was
            founded in 1912. It is now the second largest financial services
            group in Southeast Asia by assets and one of the world’s most
            highly-rated banks, with an Aa1 rating from Moody’s. Recognised for
            its financial strength and stability, OCBC Bank is consistently
            ranked among the World’s Top 50 Safest Banks by Global Finance and
            has been named Best Managed Bank in Singapore by The Asian Banker.
          </p>

          <p>
            OCBC Bank and its subsidiaries offer a broad array of commercial
            banking, specialist financial and wealth management services,
            ranging from consumer, corporate, investment, private and
            transaction banking to treasury, insurance, asset management and
            stockbroking services.
          </p>

          <p>
            OCBC Bank’s key markets are Singapore, Malaysia, Indonesia and
            Greater China. It has about 530 branches and representative offices
            in 19 countries and regions. These include over 260 branches and
            offices in Indonesia under subsidiary Bank OCBC NISP, and over 80
            branches and offices in Mainland China, Hong Kong SAR and Macau SAR
            under OCBC Wing Hang.
          </p>

          <p>
            OCBC Bank’s private banking services are provided by its
            wholly-owned subsidiary Bank of Singapore, which operates on a
            unique open-architecture product platform to source for the
            best-in-class products to meet its clients’ goals.
          </p>

          <p>
            OCBC Bank&apos;s insurance subsidiary, Great Eastern Holdings, is
            the oldest and most established life insurance group in Singapore
            and Malaysia. Its asset management subsidiary, Lion Global
            Investors, is one of the largest private sector asset management
            companies in Southeast Asia.
          </p>

          <p>
            OCBC Global Enterprise Banking has been supporting SMEs in key
            markets of Singapore, Malaysia, Indonesia and Greater China. Our
            industry expertise, strong regional network and innovative banking
            solutions have helped customers achieve their ambitions across the
            business life cycle. Our successful partnerships with SMEs have
            earned us industry recognition with the following awards:{" "}
          </p>

          <ul className="mb-4 list-outside list-decimal pl-8">
            <li>
              Asia&apos;s Best Bank for SMEs by Euromoney Awards for Excellence
              2016 - 2019
            </li>
            <li>
              Best SME Bank in Southeast Asia by Alpha Southeast Asia, 2013 –
              2017, 2020
            </li>
            <li>
              ASEAN SME Bank of the Year by Asian Banking Finance, 2011 - 2019
            </li>
            <li>
              Best SME Bank in Singapore by Alpha Southeast Asia 2010, 2011,
              2013 – 2017, 2020
            </li>
            <li>Singapore&apos;s Best Bank for SMEs 2019</li>
            <li>Myanmar Best International Bank 2018 - 2020</li>
          </ul>

          <p>
            For more information, please visit&nbsp;
            <a
              className="text-blue-175 hover:text-gray-750"
              href={OCBC_BANKING_URL}
              target="_blank"
              rel="noreferrer"
            >
              www.ocbc.com.sg/business-banking
            </a>
          </p>
        </div>
      </AccordionV2>
    </div>
  );
};

export default OCBCBankSection;
